// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"9ec97c5f","615":"0a1a5263","786":"88360217","867":"f982a7ef","898":"9412b768","921":"fa5abebd","959":"1b405a28"}[chunkId] + ".chunk.js";
};